module.exports = __webpack_public_path__ + "static/1_1_defineai_NB-5265496ad9fd8410e6f2a26347c77c5d.svg";